import * as yup from 'yup'

export class EmailAlreadyExistsError extends Error {
  constructor(message) {
    super(message)
    this.name = 'EmailAlreadyExistsError'
    this.title = 'Este correo ya está registrado'
    this.message = 'Podés ingresar otro o contactarte con el sector de Logística.'
  }
}

export const verficarEmailSchema = yup.object().shape({
  email: yup
    .string()
    .matches(
      /^[a-zA-Z0-9ñÑ._%+-]+@[a-zA-Z0-9]+([.-][a-zA-Z0-9]+)*\.[a-zA-Z]{2,}$/,
      'Ingresá un mail válido.'
    )
})